
import { useToast } from "../../../hooks/ToastContext";
import BadgeIcon from "../../../Icons/BadgeIcon";


function YtSubmitVideo({ entryjson, inputs, setInputs, saveMemberEntry }) {
    const { showToast } = useToast();

    const entrydet = JSON.parse(entryjson.entry);
    const handleChange = e => {

        setInputs(inputs => {
            return {
                ...inputs,
                [e.target.name]: e.target.value
            }
        });

    };

    const saveEntry = () => {

        const youtubeRegex = /^(https?:\/\/(?:www\.)?(?:youtube|youtu)\.(?:com\/(?:[^/\n\s]+\/\S+|(?:v|e(?:mbed)?)\/?([^/\n\s]+))|(?:\S{11})))/;

        if (!youtubeRegex.test(inputs?.entry_val)) {
            showToast("error", "Please enter a valid YouTube URL");
            return;
        }
        saveMemberEntry();

    }


    return (

        <div className="cursor-default">

            <div className="flex flex-col md:flex-row justify-between">
                <div className="md:w-[440px] w-full">
                    <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">{entrydet?.headline}</h4>
                    <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1 break-words">
                        {entrydet?.description}
                    </p>
                    <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1 break-words">
                        {entrydet?.instructions}
                    </p>
                </div>

                <div className="hidden min-[426px]:block">
                    <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
            <div className="">
                <div className="mt-2">
                    <input type="text" name="entry_val" id="entry_val" onChange={handleChange} value={inputs?.entry_val || ""} className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-500 text-[12px] md:text-[14px] sm:leading-6 placeholder:md:text-[14px] placeholder:text-[12px]" placeholder="http://www.youtube.com/watch?v=mcixldqDIEQ" autoComplete="off" />
                </div>
            </div>
            <div className="flex items-center justify-between">
                <div className="pt-2">
                    <button onClick={() => saveEntry()} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] ${!inputs?.entry_val ? 'opacity-50 cursor-not-allowed' : ' hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]'}`}>Earn Points</button>
                </div>
                <div className="pt-2">
                    <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7] sm:hidden">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default YtSubmitVideo;